// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"abbb3b33","404":"26bb9257"}[chunkId] + ".chunk.css";
};